import {
  CalendarOutlined,
  CloseCircleOutlined,
  ExceptionOutlined,
  ExclamationCircleOutlined,
  FolderOpenOutlined,
} from '@ant-design/icons'
import React, { useState, useEffect, useContext } from 'react'
import styled from 'styled-components'
import ModalCopy from 'common/Project/modalCopy'
import { Button, Checkbox, Dropdown, Form, Image, Menu, Modal } from 'antd'
import moment from 'moment'
import lang from 'lang/en'
import { useHistory } from 'react-router-dom'
import more from '../../../icons/More.svg'
import { getCookie } from 'helper/cookie'
import { deleteProject } from 'api/Project/project'
import { projectCancel, projectHold, projectSkip } from 'api/Project/status'
import Swal from 'sweetalert2'
import TextArea from 'antd/lib/input/TextArea'
import { CounterContext } from 'redux/Golbalvalues'
import { getFileSecurityFromApi } from 'api/OpenFile'
const OverviewContainer = styled.div``
const TextTitleBold = styled.h2`
  font-family: 'IBMPlexSansThaiBold';
  line-height: 2;
  color: #074e9f;
  &:hover {
    color: #0a6ee1;
  }
`

const Overviewdetails = (props) => {
  const { dataLogo, dataReport, dataProject, isLoading } = props
  const { adminPermission } = useContext(CounterContext)
  const [dataImg, setDataImg] = useState('')
  const [percentDocument, setPercentDocument] = useState(0)
  const [percentPhoto, setPercentPhoto] = useState(0)
  const [visibleModalCopy, setVisibleModalCopy] = useState(false)
  const [visibleModalDelete, setVisibleModalDelete] = useState(false)
  const [openModalCancleProject, setOpenModalCancleProject] = useState(false)
  const [openModalHoldProject, setOpenModalHoldProject] = useState(false)
  const [openModalCancleApprovalProject, setOpenModalCancleApprovalProject] = useState(
    false,
  )
  const [check, setCheck] = useState('y')
  const [valueCheck, setValueCheck] = useState(true)
  const token = getCookie('access_token_admin')
  const language = getCookie('lang')
  const word = lang[language]
  const [form_cancel] = Form.useForm()
  const [form_hold] = Form.useForm()
  const [form_cancelApprove] = Form.useForm()
  const [permission, setPermission] = useState({
    menu_id: 0,
    create: false,
    read: false,
    update: false,
    delete: false,
  })

  let roleUser = parseInt(getCookie('roleUser'))

  useEffect(() => {
    let checkPermission = false
    adminPermission?.map((item) => {
      checkPermission = true
      if (roleUser === 1) {
        setPermission((prevState) => ({
          //Adminstrator
          ...prevState,
          menu_id: 3,
          create: true,
          read: true,
          update: true,
          delete: true,
        }))
      } else if (roleUser === 9) {
        //Viewer VIP ดูได้อย่างเดียว
        setPermission((prevState) => ({
          ...prevState,
          menu_id: 3,
          create: false,
          read: true,
          update: true,
          delete: false,
        }))
      } else {
        if (item.menu_id === 2 || item.menu_id === 3 || item.menu_id === 25) {
          //  2 project list  -------  3 project list all
          checkPermission = true
          setPermission((prevState) => ({
            ...prevState,
            menu_id: item.menu_id,
            create: item.create == 'Y' ? true : false,
            read: item.read == 'Y' ? true : false,
            update: item.update == 'Y' ? true : false,
            delete: item.delete == 'Y' ? true : false,
          }))
        }
      }
    })
    if (!checkPermission && adminPermission.length > 0) {
      history.push('/no-permission')
    }
  }, [adminPermission])

  useEffect(() => {
    let cal = 0
    let cal2 = 0
    cal = (dataReport.document * 100) / dataReport.total
    cal2 = (dataReport.image * 100) / dataReport.total
    setPercentDocument(cal)
    setPercentPhoto(cal2)
  }, [dataReport])

  useEffect(() => {
    const fetchData = async () => {
      const response = await getFileSecurityFromApi({
        url: dataLogo,
        token,
      })
      const { data } = response
      const blobUrl = URL.createObjectURL(data)
      setDataImg(blobUrl)
    }

    fetchData()
  }, [dataLogo])

  const history = useHistory()

  const onChangeCheckBox = (value) => {
    setValueCheck(!valueCheck)
    if (!value.target.checked) {
      setCheck('N')
    } else {
      setCheck('Y')
    }
  }

  const checkboxApprove = (type) => {
    return (
      <Checkbox
        className='checkbox'
        value={check}
        checked={valueCheck}
        onChange={onChangeCheckBox}
        style={{ alignSelf: type === 'hold' ? 'end' : 'unset' }}
      >
        Require Approval
      </Checkbox>
    )
  }

  const modalCopy = () => {
    return (
      <ModalCopy
        visibleModalCopy={visibleModalCopy}
        setVisibleModalCopy={setVisibleModalCopy}
        type={'project'}
        id_project={dataProject?.id}
        // refreshPage={SearchCardlist}
      />
    )
  }

  const goEditProject = (data) => {
    history.push({
      pathname: `/project/${data}/edit`,
      search: '?returnTo=project-card',
    })
  }

  const goActivity = (data) => {
    history.push(`/activity/${data.id}`)
  }

  const goReschedule = (data) => {
    history.push(`/reschedule/${data.id}`)
  }

  const handleCopyProject = () => {
    setVisibleModalCopy(true)
  }

  const handleCancel = (value) => {
    const data = {
      project_id: parseInt(dataProject?.id),
      remark: value.reason_cancel_form,
    }
    try {
      projectCancel({
        params: data,
        token: token,
      }).then((res) => {
        const { data, status } = res
        if (status === 200) {
          history.push({
            pathname: '/project-list',
          })
        } else if (status === 400) {
          form_cancel.resetFields()
          return Swal.fire('Error', `${data?.errorDesc}`, 'error')
        }
      })
    } catch (error) {
      console.log(error)
    }
    setOpenModalCancleProject(false)
  }

  const onCancelProject = () => {
    setOpenModalCancleProject(true)
  }

  const onCancleApproval = () => {
    setOpenModalCancleApprovalProject(true)
  }

  const handleDelete = () => {
    try {
      deleteProject({
        project_id: dataProject?.id,
        token: token,
      }).then((res) => {
        if (res.status === 200) {
          history.push({
            pathname: '/project-list',
          })
        }
      })
    } catch (error) {
      console.log(error)
    }
    setVisibleModalDelete(false)
  }

  const handleHold = (value) => {
    let data = {
      project_id: parseInt(dataProject?.id),
      remark: value.reason_hold_form,
      approve: check,
    }
    try {
      projectHold({
        params: data,
        token: token,
      }).then((res) => {
        const { data, status } = res
        if (status === 200) {
          history.push({
            pathname: '/project-list',
          })
        } else if (status === 400) {
          form_hold.resetFields()
          return Swal.fire('Error', `${data?.errorDesc}`, 'error')
        }
      })
    } catch (error) {
      console.log(error)
    }
    setOpenModalHoldProject(false)
  }

  const handleSkip = (value) => {
    const data = {
      project_id: parseInt(dataProject?.id),
      remark: value.reason_cancelApprove_form,
    }
    try {
      projectSkip({
        params: data,
        token: token,
      }).then((res) => {
        const { data, status } = res
        if (status === 200) {
          history.push({
            pathname: '/project-list',
          })
        } else if (status === 400) {
          form_cancelApprove.resetFields()
          return Swal.fire('Error', `${data?.errorDesc}`, 'error')
        }
      })
    } catch (error) {
      console.log(error)
    }
    setOpenModalCancleApprovalProject(false)
  }

  const modalCancel = () => {
    return (
      <Modal
        maskClosable={false}
        className='DeleteModal'
        visible={openModalCancleProject}
        okText={'Confirm'}
        onOk={form_cancel.submit}
        onCancel={() => setOpenModalCancleProject(false)}
        destroyOnClose
      >
        <Form
          className='body-form'
          form={form_cancel}
          onFinish={handleCancel}
          name='form_cancel'
        >
          <CloseCircleOutlined className='CloseCircleOutlined' />
          <h2>{word['btnStatus_title_cancel']}</h2>
          <h4>{word['btnStatus_des_cancel']}</h4>
          <Form.Item
            className='subform'
            id='reason_cancel_form'
            name='reason_cancel_form'
            rules={[
              {
                whitespace: true,
                required: true,
                message: '* Please tell a reason',
              },
            ]}
          >
            <TextArea
              id='reason_cancel'
              name='reason_cancel'
              placeholder='Please tell a reason'
              autoSize={{ minRows: 1, maxRows: 4 }}
            />
          </Form.Item>
        </Form>
      </Modal>
    )
  }

  const modalHold = () => {
    return (
      <Modal
        maskClosable={false}
        className='ModalStatusOption'
        visible={openModalHoldProject}
        okText={'Confirm'}
        onOk={form_hold.submit}
        onCancel={() => setOpenModalHoldProject(false)}
        destroyOnClose
      >
        <Form
          className='body-form'
          form={form_hold}
          onFinish={handleHold}
          name='form_hold'
        >
          <ExclamationCircleOutlined className='exclamationCircleOutlined' />
          <h2>{word['btnStatus_title_hold']}</h2>
          <h4>{word['btnStatus_des_hold']}</h4>
          <Form.Item
            className='subform'
            id='reason_hold_form'
            name='reason_hold_form'
            rules={[
              {
                whitespace: true,
                required: true,
                message: '* Please tell a reason',
              },
            ]}
          >
            <TextArea
              id='reason_hold'
              name='reason_hold'
              placeholder='Please tell a reason'
              autoSize={{ minRows: 1, maxRows: 4 }}
            />
          </Form.Item>
          {checkboxApprove('hold')}
        </Form>
      </Modal>
    )
  }

  const modalSkip = () => {
    return (
      <Modal
        maskClosable={false}
        className='ModalStatusOption'
        visible={openModalCancleApprovalProject}
        onOk={form_cancelApprove.submit}
        okText={'Confirm'}
        cancelText={'Close'}
        onCancel={() => setOpenModalCancleApprovalProject(false)}
        destroyOnClose
      >
        <Form
          name='form_cancelApprove'
          form={form_cancelApprove}
          className='body-form'
          onFinish={handleSkip}
        >
          <ExceptionOutlined className='ExceptionOutlined' />
          <h2>{word['btnStatus_title_skip']}</h2>
          <h4>{word['btnStatus_des_skip']}</h4>
          <Form.Item
            className='subform'
            id='reason_cancelApprove_form'
            name='reason_cancelApprove_form'
            rules={[
              {
                whitespace: true,
                required: true,
                message: '* Please tell a reason',
              },
            ]}
          >
            <TextArea
              id='reason_cancelApprove'
              name='reason_cancelApprove'
              placeholder='Please tell a reason'
              autoSize={{ minRows: 1, maxRows: 4 }}
            />
          </Form.Item>
        </Form>
      </Modal>
    )
  }

  const onHoldProject = () => {
    setOpenModalHoldProject(true)
  }

  const gotoFileBrowser = () => {
    const urlPage = window.location.href
    const split = urlPage.split('/')
    let idProject = split[4]
    history.push({
      pathname: `/overview/${idProject}/projectfile`,
      state: dataProject,
    })
  }
  const renderNewfunction = () => {
    return (
      <div className='indiv'>
        <div className='custom-progress'>
          <div
            className='percent-type-document'
            style={{ width: `${percentDocument}%` }}
          ></div>
          <div className='percent-type-photo' style={{ width: `${percentPhoto}%` }}></div>
        </div>

        <div className='report'>
          <div className='item1'>
            <h5>Total</h5>
            <h1>{dataReport.total}</h1>
          </div>

          <div className='item2'>
            <h5>Document</h5>
            <h1>{dataReport.document}</h1>
          </div>

          <div className='item3'>
            <h5>Photo</h5>
            <h1>{dataReport.image}</h1>
          </div>
        </div>

        <Button
          type='primary'
          className='btn_Secondary2'
          onClick={() => gotoFileBrowser()}
          disabled={!isLoading}
        >
          <FolderOpenOutlined className='Icon-color' />
          Open File Browser
        </Button>
      </div>
    )
  }
  const color_dayleft_sd = (val) => {
    return (val.status_id === 21 || val.status_id === 9) &&
      (val.schedule_deviation > 10 || val.schedule_deviation < -10)
      ? 'status-Cancel-color'
      : (val.status_id === 21 || val.status_id === 9) &&
        (val.schedule_deviation <= 10 || val.schedule_deviation >= -10)
      ? 'status-Done-color'
      : val.status_id !== 21 && val.status_id !== 9 && val.day_left <= 7
      ? 'status-Cancel-color'
      : 'status-Done-Delayed-color'
  }
  const show_dayleft_sd = (val) => {
    return val.status_id === 21 || val.status_id === 9
      ? `SD: ${val.schedule_deviation}%`
      : `${val.day_left} days left`
  }
  const ElipsisFormatter = (text) => {
    if (text) {
      const FindHtmlTag_Spacebar = text.replaceAll('&nbsp;', ' ')
      const FindHtml_space = FindHtmlTag_Spacebar.replaceAll('&nbsp', ' ')
      const FindHtmlTag_Enter = FindHtml_space.replaceAll('\n', '<br />')
      return FindHtmlTag_Enter
    } else {
      return ''
    }
  }
  const RenderTextProject = (textProject) => {
    return (
      <p
        style={{
          border: '1px solid #EFEFEF',
          borderRadius: '8px',
          height: '80px',
          padding: '6px 3px 0px 15px',
        }}
        className='cutter-text-line-multi'
      >
        <div
          style={{ height: '65px', overflow: 'auto', lineHeight: '23px' }}
          dangerouslySetInnerHTML={{
            __html: ElipsisFormatter(textProject),
          }}
        />
      </p>
    )
  }

  const modalDelete = () => {
    return (
      <Modal
        maskClosable={false}
        className='DeleteModal'
        visible={visibleModalDelete}
        okText={'Delete'}
        onOk={handleDelete}
        onCancel={() => setVisibleModalDelete(false)}
      >
        <CloseCircleOutlined className='CloseCircleOutlined' />
        <h2>{word['btnStatus_title_delete']}</h2>
        <h4>{word['btnStatus_des_delete']}</h4>
      </Modal>
    )
  }

  const menu = (data) => {
    return (
      <Menu>
        <Menu.Item key='0' onClick={() => goEditProject(data.id)}>
          {word['Edit']}
        </Menu.Item>
        <Menu.Item key='1' onClick={() => goActivity(data)}>
          {word['Project_Activity']}
        </Menu.Item>
        <Menu.Item
          key='2'
          hidden={permission.update ? false : true}
          onClick={() => goReschedule(data)}
        >
          {word['Reschedule']}
        </Menu.Item>
        <Menu.Item
          key='3'
          onClick={() => handleCopyProject()}
          hidden={permission.create ? false : true}
        >
          {word['Copy']}
        </Menu.Item>
        <Menu.Item
          key='4'
          hidden={
            data.status_id === 4 ||
            data.status_id === 6 ||
            data.status_id === 7 ||
            data.status_id === 3 ||
            data.status_id === 5 ||
            data.status_id === 28 ||
            data.status_id === 8
              ? permission.update
                ? false
                : true
              : true
          }
          onClick={() => onCancelProject()}
        >
          {word['CancelProject']}
        </Menu.Item>
        <Menu.Item
          key='5'
          hidden={data.status_id === 6 ? (permission.update ? false : true) : true}
          onClick={() => onHoldProject()}
        >
          {word['Hold']}
        </Menu.Item>
        <Menu.Item
          hidden={
            !(
              (permission.delete && data.status_id === 2) ||
              (permission.delete && permission.menu_id === 3) ||
              (permission.delete && permission.menu_id === 25)
            )
          }
          onClick={() => {
            setVisibleModalDelete(true)
          }}
          key='6'
        >
          {word['Delete']}
        </Menu.Item>
        <Menu.Item
          key='7'
          hidden={
            data.status_id === 3 ||
            data.status_id === 5 ||
            data.status_id === 28 ||
            data.status_id === 8
              ? permission.update
                ? false
                : true
              : true
          }
          onClick={() => onCancleApproval()}
        >
          {word['CancelApproval']}
        </Menu.Item>
      </Menu>
    )
  }

  return (
    <>
      {modalCopy()}
      {modalDelete()}
      {modalCancel()}
      {modalHold()}
      {modalSkip()}
      <OverviewContainer className='overviews-container'>
        <div>
          <div className='subcontainer-1'>
            <div className='column-1'>
              <Image className='largeicon' src={dataImg} />

              <div className='sub-column-1'>
                <p
                  className='hoverOverviewId'
                  onClick={() => goEditProject(dataProject.id)}
                >
                  {props.dataProject.id}
                </p>
                <div style={{ display: 'grid', paddingRight: '12px' }}>
                  <TextTitleBold
                    style={{ cursor: 'pointer' }}
                    className='cutter-text-line-1'
                    onClick={() => goEditProject(dataProject.id)}
                  >
                    {props.dataProject.name}
                  </TextTitleBold>
                </div>
              </div>
            </div>
            <div className='column-2'>
              <div className='log-width-status'>
                <div
                  className={`Status  ${
                    props.dataProject.status_id === 2
                      ? 'project-type-saved'
                      : props.dataProject.status_id === 4
                      ? 'project-type-registered'
                      : props.dataProject.status_id === 6
                      ? 'project-type-kickoff'
                      : props.dataProject.status_id === 7
                      ? 'project-type-onhold'
                      : props.dataProject.status_id === 9
                      ? 'project-type-complete'
                      : props.dataProject.status_id === 21
                      ? 'project-type-completedwithdelay'
                      : props.dataProject.status_id === 19
                      ? 'project-type-cancelled'
                      : props.dataProject.status_id === 3
                      ? 'project-type-waitingforapprove-register'
                      : props.dataProject.status_id === 5
                      ? 'project-type-waitingforapprove-kickoff'
                      : props.dataProject.status_id === 8
                      ? 'project-type-waitingforapprove-complete'
                      : 'project-type-waitingforapprove-hold'
                  }`}
                >
                  {props.dataProject.status}
                </div>
                <Dropdown
                  overlay={(e) => menu(props?.dataProject)}
                  trigger={['click']}
                  placement='bottomRight'
                >
                  <a
                    className='ant-dropdown-link'
                    style={{ marginTop: '4px', marginLeft: '19px' }}
                    onClick={(e) => e.preventDefault()}
                  >
                    <img src={more} />
                  </a>
                </Dropdown>
              </div>
              <div className='Date'>
                <CalendarOutlined className='calendaroutlined' />
                <p>
                  {moment(props.dataProject.kickoff).format('DD MMM YYYY')} -{' '}
                  {moment(props.dataProject.closure).format('DD MMM YYYY')}
                </p>
              </div>

              <h5 className={`${color_dayleft_sd(props.dataProject)}`}>
                {show_dayleft_sd(props.dataProject)}
              </h5>
            </div>
          </div>
          <div className='Responsive-event-date'>
            <div className='Date'>
              <CalendarOutlined className='calendaroutlined' />
              <div style={{ display: 'grid' }}>
                <p className='cutter-text-line-1'>
                  {moment(props.dataProject.kickoff).format('DD MMM YYYY')} -{' '}
                  {moment(props.dataProject.closure).format('DD MMM YYYY')}
                </p>
              </div>
            </div>

            <h5 className={`${color_dayleft_sd(props.dataProject)}`}>
              {show_dayleft_sd(props.dataProject)}
            </h5>
          </div>
          <div className='Line17'></div>
          <div className='subcontainer-2'>
            <div className='left-container'>
              <div className='description'>
                <h5>Project Description</h5>

                {props.dataProject.description != '' ? (
                  RenderTextProject(props.dataProject.description)
                ) : (
                  <div style={{ display: 'grid' }}>
                    <p className='cutter-text-line-multi'>no project description</p>
                  </div>
                )}
              </div>
              <div className='goal'>
                <h5>Project Goal</h5>
                {props.dataProject.goal != '' ? (
                  RenderTextProject(props.dataProject.goal)
                ) : (
                  <div style={{ display: 'grid' }}>
                    <p className='cutter-text-line-multi'>no project goal</p>
                  </div>
                )}
              </div>
            </div>
            <div className='right-container'>
              <h5>Project files</h5>

              <div className='newfunction'>{renderNewfunction()}</div>
            </div>
          </div>
        </div>
      </OverviewContainer>
    </>
  )
}

export default Overviewdetails
